import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./InterestRateChart.css";
import Seo from "../components/Seo";

const loanCategories = [
  {
    key: "homeLoan",
    label: "Home Loan",
    shortLabel: "Home Loan",
    icon: "bi bi-house-door",
    startingRate: "7.10%*",
    description:
      "Indicative home-loan rates for salaried and self-employed applicants.",
    path: "/home-loan",
  },
  {
    key: "loanAgainstProperty",
    label: "Loan Against Property",
    shortLabel: "LAP",
    icon: "bi bi-buildings",
    startingRate: "9.10%*",
    description:
      "Indicative secured-loan rates against eligible residential or commercial property.",
    path: "/loan-against-property",
  },
  {
    key: "personalLoan",
    label: "Personal Loan",
    shortLabel: "Personal Loan",
    icon: "bi bi-person-check",
    startingRate: "9.99%*",
    description:
      "Indicative unsecured personal-loan rates from selected lenders.",
    path: "/personal-loan",
  },
  {
    key: "businessLoan",
    label: "Business Loan",
    shortLabel: "Business Loan",
    icon: "bi bi-briefcase",
    startingRate: "10.75%*",
    description:
      "Indicative business-finance rates for eligible applicants and enterprises.",
    path: "/business-loan",
  },
  {
    key: "carLoan",
    label: "Car Loan",
    shortLabel: "Car Loan",
    icon: "bi bi-car-front",
    startingRate: "7.45%*",
    description:
      "Indicative vehicle-loan rates for eligible new and used car purchases.",
    path: "/car-loan",
  },
];

const rateData = {
  homeLoan: {
    salaried: [
      { bank: "Bank of India", rate: "7.10%*" },
      { bank: "Bank of Maharashtra", rate: "7.10%*" },
      { bank: "Central Bank of India", rate: "7.10%*" },
      { bank: "Bank of Baroda", rate: "7.20%*" },
      { bank: "HDFC Bank", rate: "7.20%*" },
      { bank: "State Bank of India", rate: "7.25%*" },
      { bank: "ICICI Bank", rate: "7.30%*" },
      { bank: "IDBI Bank", rate: "7.35%*" },
      { bank: "Axis Bank", rate: "7.45%*" },
      { bank: "Kotak Mahindra Bank", rate: "7.99%*" },
    ],
    selfEmployed: [
      { bank: "Bank of India", rate: "7.10%*" },
      { bank: "Bank of Maharashtra", rate: "7.10%*" },
      { bank: "Central Bank of India", rate: "7.10%*" },
      { bank: "Bank of Baroda", rate: "7.20%*" },
      { bank: "HDFC Bank", rate: "7.20%*" },
      { bank: "State Bank of India", rate: "7.25%*" },
      { bank: "ICICI Bank", rate: "7.30%*" },
      { bank: "IDBI Bank", rate: "7.35%*" },
      { bank: "Axis Bank", rate: "7.40%*" },
      { bank: "Kotak Mahindra Bank", rate: "8.15%*" },
    ],
  },

  loanAgainstProperty: {
    salaried: [
      { bank: "Bank of India", rate: "9.10%*" },
      { bank: "Axis Bank", rate: "9.25%*" },
      { bank: "IDFC FIRST Bank", rate: "9.50%*" },
      { bank: "Central Bank of India", rate: "9.50%*" },
      { bank: "IDBI Bank", rate: "9.50%*" },
      { bank: "Kotak Mahindra Bank", rate: "9.50%*" },
      { bank: "Bank of Maharashtra", rate: "9.95%*" },
      { bank: "ICICI Bank", rate: "11.10%*" },
      { bank: "HDFC Ltd.", rate: "11.80%*" },
    ],
    selfEmployed: [
      { bank: "Bank of India", rate: "9.10%*" },
      { bank: "Axis Bank", rate: "9.25%*" },
      { bank: "IDFC FIRST Bank", rate: "9.50%*" },
      { bank: "Central Bank of India", rate: "9.50%*" },
      { bank: "IDBI Bank", rate: "9.50%*" },
      { bank: "Kotak Mahindra Bank", rate: "9.50%*" },
      { bank: "Bank of Maharashtra", rate: "9.95%*" },
      { bank: "ICICI Bank", rate: "11.10%*" },
      { bank: "HDFC Ltd.", rate: "11.80%*" },
    ],
  },

  personalLoan: {
    salaried: [
      { bank: "IDFC FIRST Bank", rate: "9.99%*" },
      { bank: "Bajaj Finance", rate: "10.00%*" },
      { bank: "IndusInd Bank", rate: "10.49%*" },
      { bank: "HDFC Bank", rate: "10.90%*" },
      { bank: "Axis Bank", rate: "11.25%*" },
    ],
    selfEmployed: [
      { bank: "IDFC FIRST Bank", rate: "9.99%*" },
      { bank: "Bajaj Finance", rate: "10.00%*" },
      { bank: "IndusInd Bank", rate: "10.49%*" },
      { bank: "HDFC Bank", rate: "10.90%*" },
      { bank: "Axis Bank", rate: "11.25%*" },
    ],
  },

  businessLoan: {
    salaried: [
      { bank: "Axis Bank", rate: "10.75%*" },
      { bank: "HDFC Bank", rate: "10.75%*" },
      { bank: "IndusInd Bank", rate: "13.00%*" },
      { bank: "DBS Bank", rate: "13.00%*" },
      { bank: "Standard Chartered Bank", rate: "15.00%*" },
      { bank: "Poonawalla Fincorp", rate: "15.00%*" },
      { bank: "Deutsche Bank", rate: "16.00%*" },
    ],
    selfEmployed: [
      { bank: "Axis Bank", rate: "10.75%*" },
      { bank: "HDFC Bank", rate: "10.75%*" },
      { bank: "IndusInd Bank", rate: "13.00%*" },
      { bank: "DBS Bank", rate: "13.00%*" },
      { bank: "Standard Chartered Bank", rate: "15.00%*" },
      { bank: "Poonawalla Fincorp", rate: "15.00%*" },
      { bank: "Deutsche Bank", rate: "16.00%*" },
    ],
  },

  carLoan: {
    salaried: [
      { bank: "Bank of India", rate: "7.45%*" },
      { bank: "Bank of Maharashtra", rate: "7.45%*" },
      { bank: "Central Bank of India", rate: "7.45%*" },
      { bank: "Indian Overseas Bank", rate: "7.45%*" },
    ],
    selfEmployed: [
      { bank: "Bank of India", rate: "7.45%*" },
      { bank: "Bank of Maharashtra", rate: "7.45%*" },
      { bank: "Central Bank of India", rate: "7.45%*" },
      { bank: "Indian Overseas Bank", rate: "7.45%*" },
    ],
  },
};

const applicantTypes = [
  {
    key: "salaried",
    label: "Salaried Applicants",
    icon: "bi bi-briefcase",
  },
  {
    key: "selfEmployed",
    label: "Self-Employed Applicants",
    icon: "bi bi-person-workspace",
  },
];

const parseRate = (rate) => {
  const numericRate = parseFloat(String(rate).replace(/[^\d.]/g, ""));
  return Number.isFinite(numericRate)
    ? numericRate
    : Number.POSITIVE_INFINITY;
};

const InterestRatesChart = () => {
  const [selectedLoan, setSelectedLoan] = useState("homeLoan");
  const [applicantType, setApplicantType] = useState("salaried");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("lowest");

  const activeCategory =
    loanCategories.find((category) => category.key === selectedLoan) ||
    loanCategories[0];

  const visibleRates = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    let filteredRates = rateData[selectedLoan][applicantType].filter(
      (item) => item.bank.toLowerCase().includes(normalizedSearch)
    );

    if (sortOrder === "lowest") {
      filteredRates = [...filteredRates].sort(
        (firstItem, secondItem) =>
          parseRate(firstItem.rate) - parseRate(secondItem.rate)
      );
    }

    if (sortOrder === "highest") {
      filteredRates = [...filteredRates].sort(
        (firstItem, secondItem) =>
          parseRate(secondItem.rate) - parseRate(firstItem.rate)
      );
    }

    if (sortOrder === "name") {
      filteredRates = [...filteredRates].sort((firstItem, secondItem) =>
        firstItem.bank.localeCompare(secondItem.bank)
      );
    }

    return filteredRates;
  }, [selectedLoan, applicantType, searchTerm, sortOrder]);

  const lowestRate =
    visibleRates.length > 0
      ? visibleRates.reduce((lowest, current) =>
          parseRate(current.rate) < parseRate(lowest.rate)
            ? current
            : lowest
        )
      : null;

  return (
    <>
      <Seo
        title="Loan Interest Rate Chart | MONAYRA (OPC) PRIVATE LIMITED"
        description="Compare indicative home-loan, Loan Against Property, personal-loan, business-loan and car-loan rates from selected lenders with MONAYRA."
        keywords="loan interest rate chart, home loan rates, Loan Against Property rates, personal loan rates, business loan rates, car loan rates"
        canonical="https://www.mortbuzz.in/interest-rates-banks"
      />

      <main className="monayra-interest-chart-page">
        <section className="interest-chart-hero">
          <div className="interest-chart-hero-overlay"></div>

          <div
            className="interest-chart-glow interest-chart-glow-left"
            aria-hidden="true"
          ></div>

          <div
            className="interest-chart-glow interest-chart-glow-right"
            aria-hidden="true"
          ></div>

          <div className="interest-chart-container interest-chart-hero-grid">
            <div className="interest-chart-hero-content">
              <span className="interest-chart-eyebrow">
                Loan Rate Comparison
              </span>

              <h1>
                Compare indicative loan rates across
                <span> multiple lenders</span>
              </h1>

              <p>
                Review selected lender rates for home loans, Loan Against
                Property, personal loans, business loans and car loans in one
                organised chart.
              </p>

              <div className="interest-chart-hero-actions">
                <Link
                  to="/apply-now"
                  className="interest-chart-primary-btn"
                >
                  Apply for a Loan
                  <i className="bi bi-arrow-right"></i>
                </Link>

                <a
                  href="#loan-interest-chart"
                  className="interest-chart-secondary-btn"
                >
                  <i className="bi bi-bar-chart"></i>
                  View Rate Chart
                </a>
              </div>

              <div className="interest-chart-hero-features">
                <div>
                  <i className="bi bi-bank"></i>
                  Selected lending institutions
                </div>

                <div>
                  <i className="bi bi-funnel"></i>
                  Loan and applicant filters
                </div>

                <div>
                  <i className="bi bi-arrow-down-up"></i>
                  Rate sorting
                </div>
              </div>
            </div>

            <aside className="interest-chart-hero-card">
              <span className="interest-chart-hero-icon">
                <i className={activeCategory.icon}></i>
              </span>

              <span className="interest-chart-card-eyebrow">
                Selected Product
              </span>

              <h2>{activeCategory.label}</h2>

              <div className="interest-chart-starting-rate">
                <small>Indicative starting rate</small>
                <strong>{activeCategory.startingRate}</strong>
              </div>

              <p>{activeCategory.description}</p>

              <Link
                to={activeCategory.path}
                className="interest-chart-secondary-btn"
              >
                Explore {activeCategory.shortLabel}
                <i className="bi bi-arrow-right"></i>
              </Link>
            </aside>
          </div>
        </section>

        <section
          id="loan-interest-chart"
          className="interest-chart-comparison-section"
        >
          <div className="interest-chart-container">
            <div className="interest-chart-section-header">
              <span className="interest-chart-eyebrow">
                Indicative Interest Rates
              </span>

              <h2>
                Choose a loan type and
                <span> compare lender rates</span>
              </h2>

              <p>
                Select the loan product and applicant profile that best
                matches your requirement.
              </p>
            </div>

            <div className="interest-chart-loan-tabs">
              {loanCategories.map((category) => (
                <button
                  type="button"
                  key={category.key}
                  className={
                    selectedLoan === category.key ? "active" : ""
                  }
                  onClick={() => {
                    setSelectedLoan(category.key);
                    setSearchTerm("");
                  }}
                >
                  <span>
                    <i className={category.icon}></i>
                  </span>

                  <div>
                    <strong>{category.shortLabel}</strong>
                    <small>From {category.startingRate}</small>
                  </div>
                </button>
              ))}
            </div>

            <div className="interest-chart-toolbar">
              <div className="interest-chart-applicant-switch">
                {applicantTypes.map((type) => (
                  <button
                    type="button"
                    key={type.key}
                    className={
                      applicantType === type.key ? "active" : ""
                    }
                    onClick={() => setApplicantType(type.key)}
                  >
                    <i className={type.icon}></i>
                    {type.label}
                  </button>
                ))}
              </div>

              <div className="interest-chart-filter-controls">
                <div className="interest-chart-search">
                  <i className="bi bi-search"></i>

                  <input
                    type="search"
                    placeholder="Search bank name..."
                    value={searchTerm}
                    onChange={(event) =>
                      setSearchTerm(event.target.value)
                    }
                    aria-label="Search bank name"
                  />

                  {searchTerm && (
                    <button
                      type="button"
                      onClick={() => setSearchTerm("")}
                      aria-label="Clear bank search"
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  )}
                </div>

                <div className="interest-chart-sort">
                  <i className="bi bi-sort-down"></i>

                  <select
                    value={sortOrder}
                    onChange={(event) =>
                      setSortOrder(event.target.value)
                    }
                    aria-label="Sort interest rates"
                  >
                    <option value="lowest">Lowest Rate First</option>
                    <option value="highest">
                      Highest Rate First
                    </option>
                    <option value="name">Bank Name</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="interest-chart-overview-grid">
              <article>
                <span>
                  <i className={activeCategory.icon}></i>
                </span>

                <div>
                  <small>Loan Product</small>
                  <strong>{activeCategory.label}</strong>
                </div>
              </article>

              <article>
                <span>
                  <i
                    className={
                      applicantType === "salaried"
                        ? "bi bi-briefcase"
                        : "bi bi-person-workspace"
                    }
                  ></i>
                </span>

                <div>
                  <small>Applicant Type</small>
                  <strong>
                    {applicantType === "salaried"
                      ? "Salaried"
                      : "Self-Employed"}
                  </strong>
                </div>
              </article>

              <article>
                <span>
                  <i className="bi bi-bank"></i>
                </span>

                <div>
                  <small>Lenders Displayed</small>
                  <strong>{visibleRates.length}</strong>
                </div>
              </article>

              <article>
                <span>
                  <i className="bi bi-graph-down-arrow"></i>
                </span>

                <div>
                  <small>Lowest Listed Rate</small>
                  <strong>
                    {lowestRate ? lowestRate.rate : "Not available"}
                  </strong>
                </div>
              </article>
            </div>

            <div className="interest-chart-table-card">
              <div className="interest-chart-table-header">
                <div>
                  <span>{activeCategory.label}</span>

                  <h3>
                    {applicantType === "salaried"
                      ? "Salaried Applicants"
                      : "Self-Employed Applicants"}
                  </h3>
                </div>

                <Link
                  to="/emi-calculator"
                  className="interest-chart-calculator-link"
                >
                  <i className="bi bi-calculator"></i>
                  Calculate EMI
                </Link>
              </div>

              {visibleRates.length > 0 ? (
                <div className="interest-chart-table-wrapper">
                  <table className="interest-chart-table">
                    <thead>
                      <tr>
                        <th>Rank</th>
                        <th>Bank or Lender</th>
                        <th>Loan Product</th>
                        <th>Indicative Rate</th>
                        <th>Applicant Profile</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {visibleRates.map((item, index) => (
                        <tr key={`${item.bank}-${item.rate}`}>
                          <td>
                            <span className="interest-chart-rank">
                              {String(index + 1).padStart(2, "0")}
                            </span>
                          </td>

                          <td>
                            <div className="interest-chart-bank-name">
                              <span>
                                {item.bank
                                  .split(" ")
                                  .slice(0, 2)
                                  .map((word) => word[0])
                                  .join("")
                                  .toUpperCase()}
                              </span>

                              <strong>{item.bank}</strong>
                            </div>
                          </td>

                          <td>{activeCategory.label}</td>

                          <td>
                            <strong className="interest-chart-rate-value">
                              {item.rate}
                            </strong>
                          </td>

                          <td>
                            <span className="interest-chart-profile-badge">
                              {applicantType === "salaried"
                                ? "Salaried"
                                : "Self-Employed"}
                            </span>
                          </td>

                          <td>
                            <Link
                              to="/apply-now"
                              state={{
                                selectedBank: item.bank,
                                selectedLoanType:
                                  activeCategory.label,
                                applicantType:
                                  applicantType === "salaried"
                                    ? "Salaried"
                                    : "Self-Employed",
                              }}
                              className="interest-chart-table-btn"
                            >
                              Apply
                              <i className="bi bi-arrow-right"></i>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="interest-chart-empty-state">
                  <span>
                    <i className="bi bi-search"></i>
                  </span>

                  <h3>No matching lender found</h3>

                  <p>
                    Try another bank name or clear the search field.
                  </p>

                  <button
                    type="button"
                    onClick={() => setSearchTerm("")}
                  >
                    Clear Search
                  </button>
                </div>
              )}
            </div>

            <div className="interest-chart-table-note">
              <i className="bi bi-info-circle"></i>

              <p>
                Rates are indicative and may vary based on credit score,
                income, applicant profile, loan amount, tenure, property or
                vehicle details, business profile and lender policy.
              </p>
            </div>
          </div>
        </section>

        <section className="interest-chart-guidance-section">
          <div className="interest-chart-container">
            <div className="interest-chart-section-header">
              <span className="interest-chart-eyebrow">
                Compare More Than the Rate
              </span>

              <h2>
                Important factors to review before
                <span> choosing a lender</span>
              </h2>
            </div>

            <div className="interest-chart-guidance-grid">
              <article>
                <span>
                  <i className="bi bi-percent"></i>
                </span>

                <h3>Interest-Rate Structure</h3>

                <p>
                  Confirm whether the rate is fixed, floating, reducing
                  balance or linked to an external benchmark.
                </p>
              </article>

              <article>
                <span>
                  <i className="bi bi-receipt"></i>
                </span>

                <h3>Fees and Charges</h3>

                <p>
                  Compare processing, legal, technical, valuation,
                  documentation, insurance and foreclosure charges.
                </p>
              </article>

              <article>
                <span>
                  <i className="bi bi-calendar3"></i>
                </span>

                <h3>Loan Tenure</h3>

                <p>
                  A longer tenure may reduce the EMI but can increase the
                  total interest paid over the loan period.
                </p>
              </article>

              <article>
                <span>
                  <i className="bi bi-person-check"></i>
                </span>

                <h3>Eligibility Criteria</h3>

                <p>
                  Every lender follows different income, employer, business,
                  age, credit and documentation requirements.
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className="interest-chart-cta-section">
          <div className="interest-chart-container">
            <div className="interest-chart-cta-card">
              <div>
                <span>Need Help Comparing Lenders?</span>

                <h2>
                  Get suitable loan assistance from MONAYRA
                </h2>

                <p>
                  Share your loan requirement, income profile and city to
                  receive assistance with eligibility, documentation and
                  lender comparison.
                </p>
              </div>

              <div className="interest-chart-cta-actions">
                <Link
                  to="/apply-now"
                  className="interest-chart-primary-btn"
                >
                  Apply Now
                  <i className="bi bi-arrow-right"></i>
                </Link>

                <Link
                  to="/contact"
                  className="interest-chart-secondary-btn"
                >
                  <i className="bi bi-headset"></i>
                  Contact Our Team
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="interest-chart-disclaimer">
          <div className="interest-chart-container">
            <i className="bi bi-shield-exclamation"></i>

            <p>
              *The displayed rates are indicative values based on the data
              supplied for this website and may change without notice. Final
              interest rate, eligibility, loan amount, tenure, fees and
              approval are determined by the selected lender. MONAYRA (OPC)
              PRIVATE LIMITED provides loan assistance and does not guarantee
              approval.
            </p>
          </div>
        </section>
      </main>
    </>
  );
};

export default InterestRatesChart;